module.exports = __webpack_public_path__ + "img/Porto Apartment - 63 of 85.b6e660ae.jpeg";